import React, { FC } from 'react'
import SyndicatorInfoContainer from 'containers/Syndicators/SyndicatorInfo'

const SyndicatorInfoPage: FC = () => <SyndicatorInfoContainer />

export default SyndicatorInfoPage
